<template>
	<div v-if="isUserAllowedInLevel5or6">
		<BaseHeader :title="$t('chats').toString()" />
		<div class="main">
			<div v-if="chats">
				<div class="flex justify-between align-middle mb-4 mt-4">
					<PaginationNumberOfPages :current-page="current_page" :last-page="last_page" :total="total" class="self-center" />
					<div class="flex">
						<PaginationSizeSelect v-model="per_page" class="w-40" v-show="chats && chats.length" />
						<BasePagination v-model="current_page" :last-page="last_page" :total="total" :is-blocked="blockSearch" />
					</div>
				</div>
				<div class="flex flex-col">
					<div>
						<div class="align-middle inline-block min-w-full shadow overflow-hidden border-b border-gray-200 rounded">
							<div class="m-4" v-if="this.chats && this.chats.length <= 0">
								<b>{{ $t('no_entries_found') }}</b>
							</div>
							<table class="min-w-full" v-if="this.chats && this.chats.length > 0">
								<thead>
									<tr>
										<OverviewTableHeader :label="$t('customer').toString()" />
										<OverviewTableHeader :label="$t('subject').toString()" />
										<OverviewTableHeader :label="$t('date').toString()" />
										<OverviewTableHeader :label="$t('message').toString()" />
										<th class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-center"></th>
									</tr>
								</thead>
								<tbody class="bg-white" :class="{ 'cursor-pointer': true }">
									<tr
										v-for="chat in this.chats"
										:key="chat.id"
										class="tr odd:bg-gray-200 rounded"
										@click="$router.push({ name: 'repair_shop.chats_detail', params: { id: chat.id } })"
										:class="chat.unread > 0 ? 'font-bold' : 'font-medium'"
									>
										<td class="px-6 py-4">
											{{ chat.customer.company_name != null ? chat.customer.company_name : chat.customer.first_name + ' ' + chat.customer.last_name }}
										</td>
										<td class="px-6 py-4">
											{{
												chat.subject === 'general'
													? $t('general_title')
													: getDamageCaseLabel(
															chat.damage_case.type,
															chat.damage_case.license_plate,
															getGermanDate(new Date(chat.damage_case.created_at)),
													  )
											}}
										</td>
										<td class="px-6 py-4">{{ formatDate(chat.last_message.created_at) }}</td>
										<td class="px-6 py-4">
											{{ getContent(chat.last_message) }}
										</td>
										<td class="px-6 py-4 whitespace-no-wrap text-right text-lg font-medium">
											<font-awesome-icon :icon="['fas', 'chevron-right']" class="cursor-pointer" />
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
			<div class="flex justify-between align-middle mb-4 mt-4 m-0">
				<PaginationNumberOfPages :current-page="current_page" :last-page="last_page" :total="total" class="self-center" />
				<div class="flex">
					<PaginationSizeSelect v-model="per_page" class=" w-40" v-show="chats && chats.length" />
					<BasePagination v-model="current_page" :last-page="last_page" :total="total" :is-blocked="blockSearch" />
				</div>
			</div>
			<router-view />
		</div>
	</div>
	<Forbidden v-else />
</template>

<script>
import BaseButton from '@/components/forms/buttons/BaseButton.vue';
import { ChatsApiFactory } from '@/api/generated';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import BaseHeader from '@/components/navigation/BaseHeader.vue';
import Validate from '@/mixins/Validate';
import apiDefaults from '@/api/defaultConfiguration';
import PaginationNumberOfPages from '@/components/forms/buttons/PaginationNumberOfPages.vue';
import PaginationSizeSelect from '@/components/damagecases/forms/PaginationSizeSelect.vue';
import BasePagination from '@/components/forms/buttons/BasePagination.vue';
import OverviewTableHeader from '@/views/damagecases/OverviewTableHeader.vue';
import { getDamageCaseLabel, getGermanDate, getGermanDateTime } from '@/plugins/Utils';
import Authentication from '@/mixins/Authentication';
import Forbidden from '@/views/default/Forbidden.vue';

export default {
	name: 'ChatOverview',
	components: {
		Forbidden,
		OverviewTableHeader,
		BasePagination,
		PaginationSizeSelect,
		PaginationNumberOfPages,
		BaseHeader,
		LoadingSpinner,
		BaseButton,
	},
	mixins: [Validate, Authentication],
	data() {
		return {
			variables: {},
			chats: null,
			current_page: 1,
			last_page: 1,
			total: 0,
			per_page: { display: '25', value: 25 },
			blockSearch: false,
		};
	},
	mounted() {
		if (this.isUserAllowedInLevel5or6) {
			this.getAllChats();
		}
	},
	methods: {
		getGermanDate,
		getDamageCaseLabel,
		getContent(lastMessage) {
			switch (lastMessage.type) {
				case 'image':
					return this.$t('image');
				case 'video':
					return this.$t('video');
				case 'document':
					return this.$t('document');
				default:
					return lastMessage.content;
			}
		},
		formatDate(timestamp) {
			return getGermanDateTime(timestamp);
		},
		getAllChats() {
			ChatsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.chatsGet(this.current_page, this.per_page.value)
				.then(response => {
					console.log(response.data.data);
					this.last_page = response.data.meta.last_page;
					this.current_page = response.data.meta.current_page;
					this.total = response.data.meta.total;
					this.chats = response.data.data;
				})
				.catch(error => {
					console.log(error);
				});
		},
	},
	watch: {
		current_page: function(oldValue, newValue) {
			if (oldValue !== newValue) {
				this.getAllChats();
			}
		},
		per_page: function() {
			this.getAllChats();
		},
	},
};
</script>
